import { styled } from '@linaria/react';

// eslint-disable-next-line no-restricted-imports
import { MqMobileOnly } from '~theme/media';
import { visualHideScrollbar } from '~theme/snippets';

export const StyledScrollWithSelected = styled.div<{ gap: number }>`
	overflow: auto;
	max-width: 100%;
	padding: 3px 0;
	mask-image: linear-gradient(
		270deg,
		transparent,
		rgba(0, 0, 0, 1) 30px,
		rgba(0, 0, 0, 1) calc(100% - 30px),
		transparent
	);

	${MqMobileOnly} {
		${visualHideScrollbar};
	}
`;
export const Wrapper = styled.div<{ gap: number }>`
	display: flex;
	min-width: max-content;
	gap: ${({ gap }) => gap}px;

	&:last-child {
		padding-right: ${({ gap }) => 1.5 * gap}px;
	}

	&:first-child {
		padding-left: ${({ gap }) => 1.5 * gap}px;
	}
`;
